import {createMemoryHistory, createBrowserHistory} from 'history'

export const history = process.env.NODE_ENV === 'test' ? createMemoryHistory() : createBrowserHistory()